export const EOY_RECAP_VIEW_TYPES = {
  ADMIN: "admin",
  NON_ADMIN: "non-admin",
} as const;
